<section *ngIf="vm$ | async as vm" class="card card__container">
    <section *ngIf="isModal" class="card-header card__container--header">
        <div class="d-flex justify-content-between">
            <h5 class="card-title">Resourceplan for {{vm.sag?.beskrivelse}}</h5>
            <button (click)="onClose()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
        </div>
    </section>

    <section class="card-body card__container--body">
        <app-resourceplan-header [sag]="vm.sag"
                                 [timesatsNavne]="vm.timesatsNavne"
                                 [timeBudgets]="vm.timeBudgets"
                                 [sagsansvarlige]="vm.sagsansvarlige"
                                 [caseUserIds]="vm.caseUserIds"
                                 [users]="users$ | async"
                                 (updateClientCaseV2)="updateClientCaseV2($event)"
                                 (removeCaseUser)="removeCaseUser($event, vm.timeBudgets)"
                                 (addCaseUser)="addCaseUser($event)"
        ></app-resourceplan-header>
        <main class="card-body card__container--body">
            <section class="px-3">
            <app-resourceplan-table [caseUsers]="caseUsers$ | async"
                                    [timeBudgets]="vm.timeBudgets"
                                    [la]="vm.la"
                                    [ka]="vm.ka"
                                    [sag]="vm.sag"
                                    (createTimeBudget)="createTimeBudget($event)"
                                    (updateTimeBudget)="updateTimeBudget($event)"
                                    (deleteTimeBudget)="deleteTimeBudget($event)"
                                    (updateClientCaseV2)="updateClientCaseV2($event)"
            ></app-resourceplan-table>
            </section>
        </main>
    </section>

    <app-resourceplan-footer [sag]="vm.sag"
                             [user]="vm.user"
                             [timeBudgets]="vm.timeBudgets"
                             (updateClientCaseV2)="updateClientCaseV2WithReNavigte($event)"
    ></app-resourceplan-footer>
</section>
